import React, {useState} from 'react';
import {WithTranslation} from 'react-i18next';
import {ScrollView, View} from 'react-native';

import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import NavigationHeader from '/component/layout/NavigationHeader';
import SwitchSection from '/component/partial/setting/SwitchSection';
import {withTranslation} from '/provider/TranslationProvider';
import {generateCallback} from '/util/component.util';

import {styles} from './NotificationSettings.style';

interface NotificationSettingsProps extends WithTranslation {
  tt: (key: string, defaultValue: string) => string;
}

export const NotificationSettings: React.FC<NotificationSettingsProps> = ({
  tt = withTranslation.ttDefaultProp,
}: NotificationSettingsProps) => {
  const [dailySummary, setDailySummary] = useState<boolean>(false);
  const [alerts, setAlerts] = useState<boolean>(false);
  const [pentibus, setPenatibus] = useState<boolean>(false);
  const [arem, setArem] = useState<boolean>(false);
  const [teamUpdates, setTeamUpdates] = useState<boolean>(false);
  const [sandura, setSandura] = useState<boolean>(false);
  const [clientUpdates, setClientUpdates] = useState<boolean>(false);
  const [sit, setSit] = useState<boolean>(false);

  return (
    <NavigationHeader>
      <View style={styles.base}>
        <View style={styles.header}>
          <Gutter>
            <Text variant="large" style={styles.heading}>
              {tt('title', 'Notifications Settings')}
            </Text>
            <Text variant="small" emphasis="low">
              {tt(
                'description',
                'Customize which notifications you want to receive.',
              )}
            </Text>
          </Gutter>
        </View>
        <ScrollView>
          <View style={styles.content}>
            <SwitchSection
              sectionTitle={tt('general', 'General')}
              items={[
                {
                  title: tt('dailySummary', 'Daily Summary'),
                  onToggleSwitch: generateCallback({
                    func: setDailySummary,
                    params: !dailySummary,
                  }),
                  isEnabled: dailySummary,
                },
                {
                  title: tt('alerts', 'Alerts'),
                  onToggleSwitch: generateCallback({
                    func: setAlerts,
                    params: !alerts,
                  }),
                  isEnabled: alerts,
                },
              ]}
            />
            <SwitchSection
              sectionTitle={tt('performance', 'Performance')}
              items={[
                {
                  title: tt('penatibus', 'Penatibus magins'),
                  onToggleSwitch: generateCallback({
                    func: setPenatibus,
                    params: !pentibus,
                  }),
                  isEnabled: pentibus,
                },
                {
                  title: tt('arem', 'Arem handus'),
                  onToggleSwitch: generateCallback({
                    func: setArem,
                    params: !arem,
                  }),
                  isEnabled: arem,
                },
              ]}
            />
            <SwitchSection
              sectionTitle={tt('teams', 'Teams')}
              items={[
                {
                  title: tt('teamUpdates', 'Team Updates'),
                  onToggleSwitch: generateCallback({
                    func: setTeamUpdates,
                    params: !teamUpdates,
                  }),
                  isEnabled: teamUpdates,
                },
                {
                  title: tt('sandura', 'Sandura antila'),
                  onToggleSwitch: generateCallback({
                    func: setSandura,
                    params: !sandura,
                  }),
                  isEnabled: sandura,
                },
              ]}
            />
            <SwitchSection
              sectionTitle={tt('clients', 'Clients')}
              items={[
                {
                  title: tt('clientUpdates', 'Client Updates'),
                  onToggleSwitch: generateCallback({
                    func: setClientUpdates,
                    params: !clientUpdates,
                  }),
                  isEnabled: clientUpdates,
                },
                {
                  title: tt('sit', 'Sit amet'),
                  onToggleSwitch: generateCallback({
                    func: setSit,
                    params: !sit,
                  }),
                  isEnabled: sit,
                },
              ]}
            />
          </View>
        </ScrollView>
      </View>
    </NavigationHeader>
  );
};

export default withTranslation('screen.notificationSettings')(
  NotificationSettings,
);
